<template>
    <div>
        <vue-element-loading :active="isLoading" is-full-screen  text="Please wait..." />
        <div class="report-box">
            
            <table>
                <thead>
                    <tr>
                        <td colspan="12">
                            <span style="margin-left:10px;">{{pulseTxt1}}</span>
                            <span style="margin-left:20px;"><button type="button" class="btn btn-outline-secondary btn-sm" @click="prevPage">{{$t("last_wave")}}</button></span>
                            <span style="margin-left:10px;"><button type="button" class="btn btn-outline-secondary btn-sm" @click="nextPage">{{$t("next_wave")}}</button></span>
                            <b-dropdown dropright :text="count_text" variant="outline-secondary" style="margin-left:10px;" size="sm">
                                <b-dropdown-item v-for="(item, index) in pageLength" :key="index" @click="chageCountValue(item)">{{ item }}</b-dropdown-item>
                            </b-dropdown>
                        </td>
                    </tr>
                </thead>
                <tr>
                    <td colspan="6">
                        <div>
                            <LineChart :chart-data="lineChartData" />
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="report-box" style="margin-top:20px;">
            <!-- <vue-element-loading :active="isLoading1" text="Please wait..." /> -->
            <div>
                <div>
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Single FiveOrder Point Length</th>
                                <th>A1</th>
                                <th>A2</th>
                                <th>A3</th>
                                <th>B1</th>
                                <th>B2</th>
                                <th>B3</th>
                                <th>c1</th>
                                <th>c2</th>
                            </tr>
                        </thead>
                        <tbody>
                            <td>長度(length*0.0056*1000)(ms)</td>
                            <td v-for="(item, index) in reportData" :key="index">{{item}}</td>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="report-box" style="margin-top:40px;">
            <!-- <vue-element-loading :active="isLoading1" text="Please wait..." /> -->
            <div>
                <div>
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Single FiveOrder Point to Point</th>
                                <th>{{$t("txt_16")}}</th>
                                <th>f1</th>
                                <th>f2</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in pulseWidthData" :key="index">
                                <td>{{item.title}}</td>
                                <td>{{item.width}}</td>
                                <td>{{item.f1}}</td>
                                <td>{{item.f2}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="report-box" style="margin-top:40px;">
            <div>
                <table class="table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>{{$t("txt_17")}}</th>
                            <th>systolic_B1</th>
                            <th>systolic_B2</th>
                            <th>A3_Left</th>
                            <th>A3_Right</th>
                        </tr>
                    </thead>
                    <tbody>
                        <td>Value(ms)</td>
                        <td v-for="(item, index) in reportInfo" :key="index">{{item}}</td>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import LineChart from '@/components/chart/chart.vue'
export default {
    components: {
      LineChart
    },
    data() {
        return{
            account: '',
            report_id: '',

            pressure_range: [],

            reportData: [],
            pulseWidthData: [],
            reportInfo: [],

            lineChartData: {
                labels: [],
                datasets: []
            },

            pulseTxt1: '第 1 分波',
            pressureRangeTxt: '126 ~ 120',
            pageNow: 1,
            pageLength: 0,
            num: 1,
            count_text: '1',

            isLoading: false
        }
    },
    created(){
        const report = JSON.parse(sessionStorage.getItem('client_report'));
        this.report_id = report.id;
        this.getReportRowIndexCount();
        this.getReportFiveOrderRow();
        this.getReportFiveOrderPoint();
        this.getReportFiveOrderPulseWidth();
        this.getReportFiveOrderInfo();
    },
    methods: {
        getReportFiveOrderRow() {
            this.isLoading = true
            const api = `${process.env.VUE_APP_APIPATH}/client/report/fiveOrder/row`;
            const json = {
                report_id: this.report_id,
                row_id: this.num
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.drawPulse(res.data.data);
                }
                this.isLoading = false
            })
        },
        getReportFiveOrderPoint() {
            this.isLoading = true
            const api = `${process.env.VUE_APP_APIPATH}/client/report/fiveOrder/point`;
            const json = {
                report_id: this.report_id,
                row_id: this.num
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.reportData = res.data.data;
                }
                this.isLoading = false
            })
        },
        getReportFiveOrderPulseWidth() {
            this.isLoading = true
            const api = `${process.env.VUE_APP_APIPATH}/client/report/fiveOrder/pulseWidth`;
            const json = {
                report_id: this.report_id,
                row_id: this.num
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.pulseWidthData = res.data.data;
                }
                this.isLoading = false
            })
        },
        getReportFiveOrderInfo() {
            this.isLoading = true
            const api = `${process.env.VUE_APP_APIPATH}/client/report/fiveOrder/info`;
            const json = {
                report_id: this.report_id,
                row_id: this.num
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.reportInfo = res.data.data;
                }
                this.isLoading = false
            })
        },
        getReportRowIndexCount() {
            this.isLoading = true;
            const api = `${process.env.VUE_APP_APIPATH}/client/report/row/count`;
            const json = {
                report_id: this.report_id,
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.pageLength = res.data.data[0].count;
                }
                this.isLoading = false;
            })
        },
        prevPage() {
            if( this.pageNow > 1 ){
                this.pageNow --;
            }
            this.count_text = this.pageNow;
            this.num = this.pageNow;
            this.pulseTxt1 = "第 " + this.num + " 分波";
            this.getReportFiveOrderRow();
            this.getReportFiveOrderPoint();
            this.getReportFiveOrderPulseWidth();
            this.getReportFiveOrderInfo();
        },
        nextPage() {
            if(this.pageNow < this.pageLength){
                this.pageNow ++
            }
            this.count_text = this.pageNow;
            this.num = this.pageNow;
            this.pulseTxt1 = "第 " + this.num + " 分波";
            this.getReportFiveOrderRow();
            this.getReportFiveOrderPoint();
            this.getReportFiveOrderPulseWidth();
            this.getReportFiveOrderInfo();
        },
        chageCountValue(index) {
            this.count_text = index;
            this.num = index;
            this.pageNow = index ;
            this.pulseTxt1 = "第" + this.num + "分波";
            this.getReportFiveOrderRow();
            this.getReportFiveOrderPoint();
            this.getReportFiveOrderPulseWidth();
            this.getReportFiveOrderInfo();
        },
        drawPulse(pulse) {
            let pulseAry = [];
            let labAry = [];
            pulseAry = pulse;
            
            pulseAry.splice(0, 1);
            pulse = pulseAry.join(",");
            pulseAry.forEach((item, i) => {
                labAry.push(i);
            })
            
            let result = {
                labels: labAry,
                datasets: [
                {
                    label: 'Original',
                    backgroundColor: "transparent",
                    data: pulseAry,
                    borderColor: "rgba(29, 33, 36, .2)",
                    pointBackgroundColor: "rgba(171, 71, 188, 1)",
                    pointRadius: 1,
                }
                ]
            };
            this.lineChartData = result;
        },
    }
}
</script>